import { ClientEditModel } from "./../../../node_modules/@playcharge/common/models/backend/clients/client-edit-model";
import { ClientViewModel } from "./../../../node_modules/@playcharge/common/models/backend/clients/client-view-model";
import { HttpClient } from "@angular/common/http";
import { inject, Injectable, model } from "@angular/core";
import { Observable } from "rxjs";
import { ApiRoutes } from "../models/constants/api-routes";
import { ApiUtils } from "../utils/api-utils";

@Injectable({
    providedIn: "root",
})
export class ApiClientsService {
    private _httpClient = inject(HttpClient);

    public getClients(): Observable<ClientViewModel[]> {
        return this._httpClient.get<ClientViewModel[]>(ApiUtils.buildUrl(ApiRoutes.clients.root));
    }

    public getClient(clientId: number): Observable<ClientViewModel[]> {
        return this._httpClient.get<ClientViewModel[]>(
            ApiUtils.buildUrl(
                ApiRoutes.clients.client,
                new Map([["clientId", clientId.toString()]]),
            ),
        );
    }

    public createClient(model: ClientEditModel): Observable<ClientViewModel> {
        return this._httpClient.post<ClientViewModel>(
            ApiUtils.buildUrl(ApiRoutes.clients.root),
            model,
        );
    }

    public updateClient(model: ClientEditModel): Observable<ClientViewModel> {
        return this._httpClient.put<ClientViewModel>(
            ApiUtils.buildUrl(ApiRoutes.clients.root),
            model,
        );
    }

    public deleteClient(clientId: number): Observable<void> {
        return this._httpClient.put<void>(
            ApiUtils.buildUrl(
                ApiRoutes.clients.client,
                new Map([["clientId", clientId.toString()]]),
            ),
            model,
        );
    }
}
